import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../../axiosClient";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

export const addJob = createAsyncThunk(
  "job/addJob",
  async ({ token, formData }, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BACKEND_URL}/addJobApi`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "API call failed");
    }
  }
);

export const editJob = createAsyncThunk(
  "job/editJob",
  async ({ token, formData }, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BACKEND_URL}/updateJobApi`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "API call failed");
    }
  }
);

export const getJob = createAsyncThunk(
  "job/getJob",
  async ({ search, token, page = 1 }, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/myJobApi?keyword=${search}&page=${page}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

export const getJobDetails = createAsyncThunk(
  "job/getJobDetails",
  async ({ id, token } = {}, thunkAPI) => {
    try {
      const config = {};

      // Only add Authorization header if token exists
      if (token) {
        config.headers = { Authorization: `Bearer ${token}` };
      }

      const res = await axios.get(`${BACKEND_URL}/jobDetailsApi/${id}`, config);
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);


export const getJobApplications = createAsyncThunk(
  "job/getJobApplications",
  async ({ token, filters = {} }, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/applyJobEmployerUser`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            keyword: filters.keyword || "",
            status: filters.status || "",
            job: filters.job || "",
          },
        }
      );
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

export const editJobApplications = createAsyncThunk(
  "job/editJobApplications",
  async ({ token, formData }, thunkAPI) => {
    console.log("formData", formData);
    try {
      const res = await axios.post(
        `${BACKEND_URL}/updateApplyStatusApi`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "API call failed");
    }
  }
);

export const deleteJob = createAsyncThunk(
  "job/deleteJob",
  async ({ token, id }, thunkAPI) => {
    try {
      const res = await axios.delete(
        `${BACKEND_URL}/deleteJobApi/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return { id, message: res.data.message || "Job deleted successfully" };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Delete failed");
    }
  }
);

export const getJobByTypeCount = createAsyncThunk(
  "job/jobByType",
  async (token, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/jobByTypeApi`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

export const getJobByCategoriesCount = createAsyncThunk(
  "job/jobByCategoriesApi",
  async (token, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/jobByCategoriesApi`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

export const getJobByStatesCount = createAsyncThunk(
  "job/jobByStateApi",
  async (token, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/jobByStateApi`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

export const getJobByExperienceCount = createAsyncThunk(
  "job/jobByExperience",
  async (token, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/jobByExperienceApi`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

export const getJobCategories = createAsyncThunk(
  "job/jobCategories",
  async (role, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/jobsCategoriesApi?role_id=${role}`
      );
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

const workerJobSlice = createSlice({
  name: "workerJob",
  initialState: {
    jobData: [],
    jobDetails: [],
    pagination: {},
    jobByTypeCount: [],
    jobByExperienceCount: [],
    jobApplications: [],
    jobCategories: [],
    jobCategoriesCount: [],
    jobStatesCount: [],
    loading: false,
    error: null,
    message: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(addJob.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addJob.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload?.message || "Job created successfully";
      })
      .addCase(addJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      .addCase(editJob.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editJob.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload?.message || "Job updated successfully";
      })
      .addCase(editJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      .addCase(getJob.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getJob.fulfilled, (state, action) => {
        state.loading = false;
        state.jobData = action.payload.data;
        state.pagination = {
                    current_page: action.payload.current_page,
                    last_page: action.payload.last_page,
                    total: action.payload.total,
                    per_page: action.payload.per_page,
                };
      })
      .addCase(getJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
       .addCase(getJobDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getJobDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.jobDetails = action.payload;
      })
      .addCase(getJobDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteJob.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteJob.fulfilled, (state, action) => {
        state.loading = false;
        state.jobData = state.jobData.filter(job => job.id !== action.payload.id);
        state.message = action.payload.message;
      })
      .addCase(deleteJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getJobByTypeCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getJobByTypeCount.fulfilled, (state, action) => {
        state.loading = false;
        state.jobByTypeCount = action.payload;
      })
      .addCase(getJobByTypeCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getJobByExperienceCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getJobByExperienceCount.fulfilled, (state, action) => {
        state.loading = false;
        state.jobByExperienceCount = action.payload;
      })
      .addCase(getJobByExperienceCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getJobByCategoriesCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getJobByCategoriesCount.fulfilled, (state, action) => {
        state.loading = false;
        state.jobCategoriesCount = action.payload;
      })
      .addCase(getJobByCategoriesCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getJobByStatesCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getJobByStatesCount.fulfilled, (state, action) => {
        state.loading = false;
        state.jobStatesCount = action.payload;
      })
      .addCase(getJobByStatesCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getJobApplications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getJobApplications.fulfilled, (state, action) => {
        state.loading = false;
        state.jobApplications = action.payload;
      })
      .addCase(getJobApplications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editJobApplications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editJobApplications.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload?.message || "Job applicaion updated successfully";
      })
      .addCase(editJobApplications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      .addCase(getJobCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.jobCategories = action.payload;
      })
      .addCase(getJobCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getJobCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
  },
});

export default workerJobSlice.reducer;
